import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {setLocale, namesOfMonths} from './utils';

import Month from './Month';
import Nav from './Nav';

import './Calendar.scss';

class Calendar extends React.Component {
  constructor(props) {
    super(props);
    this.onNewMonth = this.onNewMonth.bind(this);
    this.onNewYear = this.onNewYear.bind(this);
    this.state = {
      namesOfMonths: [],
      month: null,
      year: null,
      today: null
    }
  }

  static propTypes = {
    locale: PropTypes.string,
    isISO: PropTypes.bool,
    returnCurrentMonth: PropTypes.func,
    returnThisDate: PropTypes.func,
    myEvents: PropTypes.array,
    events: PropTypes.array,
  };

  static defaultProps = {
    locale: 'en',
    isISO: true,
    myEvents: [],
    events: [],
  };

  componentWillMount() {
    setLocale(this.props.locale);
    this.setState({
      namesOfMonths: namesOfMonths(this.props.locale),
      month: moment().month(),
      year: moment().year(),
      today: moment().format()
    });
  }

  onNewMonth(month){
    this.setState({month}, () => {
      if(typeof this.props.returnCurrentMonth === 'function')
      this.props.returnCurrentMonth(this.state.year, this.state.month)
    })
  }

  onNewYear(year){
    this.setState({year}, () => {
      if(typeof this.props.returnCurrentMonth === 'function')
      this.props.returnCurrentMonth(this.state.year, this.state.month)
    })
  }

  render() {
    return (
      <div className="calendar">
        <Nav
          monthList={this.state.namesOfMonths}
          selectedMonth={this.state.month}
          year={this.state.year}
          onNewMonth={this.onNewMonth}
          onNewYear={this.onNewYear}
        />
        <Month
          locale={this.props.locale}
          year={this.state.year}
          month={this.state.month}
          today={this.state.today}
          isISO={this.props.isISO}
          returnThisDate={this.props.returnThisDate}

          myEvents={this.props.myEvents}
          events={this.props.events}
        />
      </div>
    )
  }
}

export default Calendar;



// WEBPACK FOOTER //
// ./src/app/components/Calendar/Component.js